import * as React from 'react';

import { createIcon } from '../Icon';
export const CameraOffIcon = createIcon(
  <React.Fragment>
    <line x1={1} x2={23} y1={1} y2={23} />
    <path d="M21 21H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3m3-3h6l2 3h4a2 2 0 0 1 2 2v9.34m-7.72-2.06a4 4 0 1 1-5.56-5.56" />
  </React.Fragment>,
  'CameraOffIcon'
);
